var exports = {
  "d": "SubmitReviewButton__a5Gw8m",
  "K": "ErrorMessage__QVo4dt",
};

module.exports = exports;
